const modelName = 'Brochure Requests';
const modelNameSingular = 'Brochure Request';
const endpoint = '/brochure-requests';

const setup = {
    title: modelName,
    singular: modelNameSingular,
    model: modelName.replace(/\s+/g, '-').toLowerCase(),
    canDelete: true,
    canAddNew: true,
    canSearch: true,
    endpoint,
    accessor: 'id',
};

export default setup;
